import React from 'react';
import { Col, Row } from '@saucelabs/sl-component-grid';
import { Typography } from '@saucelabs/ds-typography';

const PlansTitle: React.FC = () => (
  <Row>
    <Col
      lg={9}
      tagName="article"
    >
      <header>
        <Typography
          disableSpacing
          variant="heading-1"
        >
          Sauce Labs Testing Plans
        </Typography>
      </header>
    </Col>
  </Row>
);

export { PlansTitle };
